module.exports = __webpack_public_path__ + "static/media/asi-component.c15c87ef.png";